import { DefaultLayout, type AvatarMenuItem } from '@cloudmatize/traffic-hub'
import { useKeycloak } from '@react-keycloak/web'
import {
  MdLock,
  MdLogout,
  MdOutlineCrisisAlert,
  MdOutlineFolderSpecial,
  MdOutlineMap,
} from 'react-icons/md'
import { useState } from 'react'
import { Sidebar, SidebarGroup, SidebarItem, SidebarSubItem } from '@cloudmatize/go-design-system'
import { IconType } from 'react-icons'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

interface MenuItem {
  label: string
  icon: IconType
  navigate: string
  children?: Array<{ label: string; navigate: string }>
}

const mappingMenuItems: MenuItem[] = [
  {
    label: 'Central Viária',
    icon: MdOutlineCrisisAlert,
    navigate: '/',
    children: [
      {
        label: 'Visão Geral',
        navigate: '/',
      },
      {
        label: 'Semáforos críticos',
        navigate: '/#traffic-lights-critials',
      },
      {
        label: 'Trechos críticos',
        navigate: '/#traffic-routes-critials',
      },
    ],
  },
  {
    label: 'Mapa',
    navigate: '/map',
    icon: MdOutlineMap,
  },
  {
    label: 'Favoritos',
    navigate: '/favorites',
    icon: MdOutlineFolderSpecial,
  },
]

export function AppLayout() {
  const { keycloak } = useKeycloak()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const navigate = useNavigate()
  const { pathname, hash } = useLocation()

  const avatarMenuItems: AvatarMenuItem[] = [
    {
      label: 'Alterar senha',
      icon: MdLock,
      onClick: () => window.open(keycloak.createLoginUrl({ action: 'UPDATE_PASSWORD' }), '_blank'),
    },
    {
      label: 'Sair da plataforma',
      icon: MdLogout,
      onClick: () => {
        keycloak?.logout()
      },
    },
  ]

  return (
    <div className="flex w-screen h-screen">
      <Sidebar
        className="bg-neutral-0"
        collapsed={isCollapsed}
        onToggle={() => setIsCollapsed(!isCollapsed)}
        logo={<img src="/logo-full.svg" />}
        logoIcon={<img src="/logo-icon.svg" />}
        footer={
          <div className={`flex gap-2 items-center ${isCollapsed ? 'flex-col' : 'flex-row'}`}>
            <span className="font-system m-0 p-0 text-2xs leading-2xs text-primary">
              developed by
            </span>

            <img src="/smart-cloud-footer.svg" />
          </div>
        }
      >
        {mappingMenuItems.map((item) => {
          if (item.children) {
            if (isCollapsed) {
              return (
                <div
                  key={item.label}
                  onClick={() => navigate(item.navigate)}
                  className="cursor-pointer"
                >
                  <SidebarGroup icon={item.icon} title={item.label} value={item.label}>
                    {item.children.map((child) => (
                      <SidebarSubItem
                        key={child.label}
                        onClick={() => navigate(child.navigate)}
                        isActive={`${pathname}${hash}` === child.navigate}
                      >
                        {child.label}
                      </SidebarSubItem>
                    ))}
                  </SidebarGroup>
                </div>
              )
            }
            return (
              <SidebarGroup key={item.label} icon={item.icon} title={item.label} value={item.label}>
                {item.children.map((child) => (
                  <SidebarSubItem
                    key={child.label}
                    onClick={() => navigate(child.navigate)}
                    isActive={`${pathname}${hash}` === child.navigate}
                  >
                    {child.label}
                  </SidebarSubItem>
                ))}
              </SidebarGroup>
            )
          }
          return (
            <SidebarItem
              icon={item.icon}
              onClick={() => navigate(item.navigate)}
              asChild={!!item?.children}
              key={item.label}
              isActive={pathname === item.navigate}
            >
              {item.label}
            </SidebarItem>
          )
        })}
      </Sidebar>
      <div className="flex-1">
        <DefaultLayout
          mapZoom={17}
          avatarMenuItems={avatarMenuItems}
          clientLogo={
            import.meta.env.VITE_CLIENT_LOGO ??
            'https://www.comunicacao.pr.gov.br/sites/default/arquivos_restritos/files/imagem/2021-07/60f9e5827c71d-GovernoParanaH%28rgb-Positivo%29.png'
          }
        >
          <Outlet />
        </DefaultLayout>
      </div>
    </div>
  )
}
